<template>  
  <div> 
    <q-item v-ripple to="/generaldashboard" style="color: black">
      <q-item-section avatar>
        <q-icon name="dashboard" />
      </q-item-section>
      <q-item-section>{{$t('global.Dashboard')}}</q-item-section>
    </q-item>  
    <q-item v-ripple to="/" style="color: black" class="other">
      <q-item-section avatar>
        <q-icon name="satellite" />
      </q-item-section>
      <q-item-section>{{$t('global.ShowMap')}}</q-item-section>
    </q-item>  
    <q-expansion-item expand-separator icon="info_outline" :label="$t('global.TrackingLive')" @after-show="showMap">
      <DeviceTree class="inset" v-if="$store.state.session"></DeviceTree>
    </q-expansion-item>
    <q-expansion-item expand-separator icon="query_builder" :label="$t('global.TrackingHistory')" class="other" @show="showMap">
      <HistoryTree v-if="$store.state.session"></HistoryTree>
    </q-expansion-item>
    <q-expansion-item v-bind:class="{ hasAlerts: hasAlerts}" expand-separator icon="alarm" :label="$t('global.NewAlert')">
      <Alerts v-if="$store.state.session" @alert-count="messageAlertCount" ></Alerts>
    </q-expansion-item>
    <q-expansion-item expand-separator icon="assessment" :label="$t('global.ExcelAnalytics')" class="other">   
      <div v-if="!$q.platform.is.mobile">
        <q-item class="inset" clickable v-ripple to="/excelanalyse">
          <q-item-section avatar>
            <q-icon name="assessment" />
          </q-item-section>
          <q-item-section>{{$t('global.ExcelReports')}}</q-item-section>
        </q-item> 
        <q-item class="inset" clickable v-ripple @click="dashboard(3)">
          <q-item-section avatar>
            <q-icon name="assignment" />
          </q-item-section>
          <q-item-section>{{$t('global.AlertDashboard')}}</q-item-section>
        </q-item> 
        <q-item class="inset" clickable v-ripple @click="dashboard(4)">
          <q-item-section avatar>
            <q-icon name="assignment" />
          </q-item-section>
          <q-item-section>{{$t('global.DistanceDashboard')}}</q-item-section>
        </q-item> 
        <q-item class="inset" clickable v-ripple @click="dashboard(2)">
          <q-item-section avatar>
            <q-icon name="assignment" />
          </q-item-section>
          <q-item-section>{{$t('global.PoiDashboard')}}</q-item-section>
        </q-item> 

      </div>
      <q-item v-if="$q.platform.is.mobile">
        {{$t('global.ExcelMobileMessage')}}
      </q-item>
    </q-expansion-item>
    <q-expansion-item expand-separator icon="description" :label="$t('global.StrategyCenter')" >
      <q-item class="inset" clickable v-ripple to="/strategydashboard">
        <q-item-section avatar>
          <q-icon name="dashboard" />
        </q-item-section>
        <q-item-section>{{$t('global.Dashboard')}}</q-item-section>
      </q-item> 
      <q-item class="inset" clickable v-ripple to="/milestone">
        <q-item-section avatar>
          <q-icon name="assignment" />
        </q-item-section>
        <q-item-section>{{$t('global.Milestones')}}</q-item-section>
      </q-item> 
    </q-expansion-item>
    <q-expansion-item expand-separator icon="build" :label="$t('global.VehicleMaintenance')" class="other">
      <q-item class="inset" clickable v-ripple to="/maintenanceschedule">
        <q-item-section avatar>
          <q-icon name="check_circle_outline" />
        </q-item-section>
        <q-item-section>{{$t('global.MaintenanceStatus')}}</q-item-section>
      </q-item> 
      <q-item class="inset" clickable v-ripple to="#1" @click.native="maintenanceSchedule()">
        <q-item-section avatar>
          <q-icon name="access_alarms" />
        </q-item-section>
        <q-item-section>{{$t('global.Milestones')}}</q-item-section>
      </q-item> 
      <q-item class="inset" clickable v-ripple to="#2" @click.native="maintenanceGroup()">
        <q-item-section avatar>
          <q-icon name="group_work" />
        </q-item-section>
        <q-item-section>{{$t('global.MaintenanceGroups')}}</q-item-section>
      </q-item> 
    </q-expansion-item>
    <q-expansion-item expand-separator icon="settings" :label="$t('global.Administration')" >
      <q-item class="inset" v-if="hasMap" clickable v-ripple to="#4" @click.native="saveMap()">
        <q-item-section avatar>
          <q-icon name="save" />
        </q-item-section>
        <q-item-section>{{$t('global.MapSave')}}</q-item-section>
      </q-item> 
      <q-item class="inset" clickable v-ripple to="#5" @click.native="changeLocal()">
        <q-item-section avatar>
          <q-icon name="language" />
        </q-item-section>
        <q-item-section>{{$t('global.ChangeLanguage')}}</q-item-section>
      </q-item> 
      <q-item class="inset" clickable v-ripple to="#6">
        <q-item-section avatar>
          <q-icon name="satellite" />
        </q-item-section>
        <q-item-section>{{$t('global.ChangeMap')}}
          <q-select
          v-model="selectMap"
          :float-label="$t('global.ChangeMap')"     
          :options="selectMapOptions"
          emit-value map-options
        />
        </q-item-section>
      </q-item> 
      <q-item class="inset" clickable v-ripple to="#7" @click.native="trackExport()">
        <q-item-section avatar>
          <q-icon name="attach_file" />
        </q-item-section>
        <q-item-section>{{$t('global.ExportTracks')}}</q-item-section>
      </q-item> 
    </q-expansion-item>
    <q-item clickable v-ripple to="#7" @click.native="logout()" class="other">
      <q-item-section avatar>
        <q-icon name="exit_to_app" />
      </q-item-section>
      <q-item-section>Logout</q-item-section>
    </q-item> 
    <q-item>
      <pwa-install  
      :explainer="$t('global.InstallExplain')" 
      :descriptionheader="$t('global.InstallHeader')"
      :installbuttontext="$t('global.InstallButtonText')"
      :iosinstallinfotext="$t('global.InstallIosInfotext')"
      >
      </pwa-install>
    </q-item>
  </div>
</template>
<script>
import { openURL } from 'quasar'
import {eventBus} from '../main'
import store from '../store'
import DeviceTree from '@/components/DeviceTree'
import HistoryTree from '@/components/HistoryTree'
import Alerts from '@/components/Alerts'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'SelectEvent',
  components: {
    DeviceTree,
    HistoryTree,
    Alerts
  },
  data () {
    return {
      form: null,
      alertCnr: null,
      hasAlerts: false,
      hasMap: true,
      selectedType: 'roadmap',
      mapLabel: this.$t("global.MapSatellite"),
      selectMap: 1,
      selectMapOptions: [
        {
          label: 'GMap ' + this.$t("global.MapRoad") + ' ' + this.$t("global.Traffic"),
          value: 1
        },
        {
          label: 'GMap ' + this.$t("global.MapRoad"),
          value: 2
        },
        {
          label: 'GMap ' + this.$t("global.MapSatellite"),
          value: 3
        },
        {
          label: 'Openstreetmap',
          value: 4
        },
        {
          label: 'Openstreet CartoDb',
          value: 5
        },
        {
          label: 'Esri World Road Map',
          value: 6
        },
        {
          label: 'Map Box',
          value: 7
        },
        {
          label: 'BING Satellite',
          value: 8 
        },
        {
          label: 'BING Road',
          value: 9 
        },
        {
          label: 'BING Satellite With Labels',
          value: 10 
        },
        {
          label: 'Open Sea Map Overlay',
          value: 11 
        }
      ],
    }
  },
  methods: {
    openURL,
    openDialog(dialog){
      if(store.state.session){  
        eventBus.$emit('loadDialog', dialog)
      }
      else{
        this.$router.push({name: 'Login'});
        this.$q.notify('Bitte einloggen.')
      } 
    },
    
    logout(){
      this.$store.state.session = null
      this.$router.push({name: 'Login'});
      eventBus.$emit('logout', null)
      this.$router.go()
    },
    changeLocal () {
      var lang = 'en'
      if (this.$i18n.locale === 'de') {
        lang = 'en'  
      } 
      if (this.$i18n.locale === 'en') {
        lang = 'es'    
      }
      if (this.$i18n.locale === 'es') {
        lang = 'th' 
      }
      if (this.$i18n.locale === 'th') {
        lang = 'de'  
      }
      //Set language for our own translations:
      this.$i18n.locale = lang
      //Set language for Quasar
      if(lang == 'en'){
        lang = 'en-us'
      }

      import(
        /* webpackInclude: /(de|en-us|es|th)\.js$/ */
        `quasar/lang/${lang}`
        ).then(lang => {
        this.$q.lang.set(lang.default)
      })
      
    },
    showMap(){
      this.$router.push({name: 'Map'})
    },   
    saveMap(){
      eventBus.$emit('saveMapSettings', null)
    }, 
    maintenanceGroup(){
      //eventBus.$emit('EntityEdit', { entity: 'MaintenanceGroup', id: null })
      eventBus.$emit('loadDialog', "MaintenanceGroup")
    }, 
    maintenanceSchedule(){
      eventBus.$emit('loadDialog', "CreateMaintenanceSchedule")
    },
    trackExport(){
      if(store.state.session){  
        eventBus.$emit('loadDialog', "ExportTrack")
      }
      else{
        this.$router.push({name: 'Login'});
        this.$q.notify('Bitte einloggen.')
      } 
    },
    messageAlertCount(cnr){
      if(cnr > 0){
        this.hasAlerts = true
      }
      else{
        this.hasAlerts = false
      }
      
      if(this.alertCnr != null){
        if(cnr > this.alertCnr){
          const audio = new Audio('/sound/Alert.mp3')
          audio.play()
        }
      }
      
      this.alertCnr = cnr
    },
    dashboard(idReport){
      if(store.state.session){
        this.form = {}
        if (this.$q.platform.is.ios){
          var windowReference = window.open()
        }
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.IdDefaultReport = idReport
        axios.post(this.$apiUrlGo + "/excel/",
        qs.stringify(this.form),
        {
            responseType: 'blob', 
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then((response) => {
            const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
            }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', "Dashboard.xlsx")
            document.body.appendChild(link)
            link.click()
        })
        .catch(e => {
          this.loading = false
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
      }
    }
  },
  created () {
    eventBus.$on('loadGeoRegion', (data) => {
      this.hasMap = true
    })
    
  },

  watch: {
    selectMap: function (newValue, oldValue) {
      this.selectedType = newValue
      eventBus.$emit('changeMapType', this.selectedType)
    },
   },
   computed:{
     secondRow: function(){
       if(this.$org == 2){
          return 'otherRastrealo'
       }
       else{
          return 'other'
       }
     }
   }
  
}
</script>

<style scoped>
 .hasAlerts{
   color: red;
 }
 .otherX{
   background-color:ghostwhite
 }
 .other{
   background-color:ivory
 }
 .inset{
   margin-left: 10px;
 }
</style>